import name from './name'

const selectSliceData = state => state[name]

const selectSkillBites = state => selectSliceData(state).skillBites

const selectSkillBiteLanguage = state => selectSliceData(state).languages

const selectSkillBitesSubscriptions = state => selectSliceData(state).subscribedSkillBites

export { selectSkillBites, selectSkillBiteLanguage, selectSkillBitesSubscriptions }
